export default __webpack_public_path__ + "static/media/cake.04ebccbf.webp";